import {UIGeneralServicesController} from '../../shared/scripts/UIGeneralServicesController'
import {UINotificationActionController} from '../../shared/scripts/notifications/UINotificationActionController'
import {UIWOnlineFriendController} from './ui_friends/UIWOnlineFriendController'
import {UIMinimalHeaderController} from './ui_html/new_layout/UIMinimalHeaderController'
import {UIManager} from './ui_html/UIManager'

export class UIWGeneralServicesController extends UIGeneralServicesController {
    constructor(uiManager: UIManager | undefined, uiHeaderController: UIMinimalHeaderController | undefined) {
        super()
        this.onlineFriendController = new UIWOnlineFriendController(uiManager?.room, uiHeaderController?.notificationPanelController)

        if(!uiHeaderController?.notificationPanelController) return
        this.notificationActionController = new UINotificationActionController(uiHeaderController.notificationPanelController)
    }

    init() {
        this.onlineFriendController?.init()
    }
}
